module.exports = __webpack_public_path__ + "img/tocantins.19841bcf.jpg";